import { Link } from "react-router-dom";
import type { ContentTopic } from "@/types/content";

export function formatCount(value: number) {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return `${value}`;
}

export default function TopicCard({ topic }: { topic: ContentTopic }) {
  return (
    <article className="reveal group h-full flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/80 hover:border-primary-300 transition-colors duration-300">
      <Link
        to={`/topic/${topic.id}`}
        className="relative block w-full h-48 overflow-hidden shrink-0"
        aria-label={topic.title}
      >
        <img
          src={topic.cover}
          alt={`${topic.title} - 瓜田吃瓜话题配图`}
          title={`${topic.title} - 瓜田吃瓜热门话题`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/95 text-xs text-primary-700 border border-primary-200">
          {topic.category}
        </span>
      </Link>

      <div className="flex flex-col flex-1 p-4 md:p-5">
        <h3 className="text-sm md:text-base font-bold text-foreground-950 leading-snug">
          <Link to={`/topic/${topic.id}`} className="hover:text-primary-700 transition-colors">
            {topic.title}
          </Link>
        </h3>
        <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600 line-clamp-2">
          {topic.summary}
        </p>

        <div className="mt-auto pt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-fire-line text-primary-500 w-4 h-4 flex items-center justify-center" />
            热度 {formatCount(topic.heat)}
          </span>
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-chat-3-line w-4 h-4 flex items-center justify-center" />
            {formatCount(topic.comments)} 讨论
          </span>
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
            {formatCount(topic.views)}
          </span>
        </div>
      </div>
    </article>
  );
}